import {useAssetsHistoryQuery} from '@domain/assets'
import type {BaseSchedule} from '@domain/schedule'
import {useUpmPlantContext} from '@hconnect/upm'
import {Moment} from 'moment-timezone'
import {useMemo} from 'react'

import {mapScheduleItemIdToAssetData} from '../utils'

interface AssetHistoryDataByScheduleItemIdParams {
  timeFrame: [Moment, Moment]
  schedule: BaseSchedule | undefined
}

export const useAssetHistoryDataByScheduleItemId = ({
  timeFrame,
  schedule
}: AssetHistoryDataByScheduleItemIdParams) => {
  const {plantId} = useUpmPlantContext()
  const {data: assetsHistory} = useAssetsHistoryQuery({
    plantId,
    timeFrame
  })

  return useMemo(() => {
    if (!schedule || !assetsHistory) {
      return undefined
    }
    return mapScheduleItemIdToAssetData(schedule.schedules, assetsHistory)
  }, [schedule, assetsHistory])
}
